import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import GeneralSignupForm from './General';
import OwnerSignupForm from './PetOwner';
import PetSitterSignupForm from './PetSitter';
import { signup } from './action';
import { selectIsUserAuthenticated } from '../Auth/selector';
import {
  selectGeneralFormError,
  selectOwnerOrSitterFormError,
} from './selector';

const Signup = () => {
  const [currentScreen, setCurrentScreen] = useState(0);
  const [formData, setFormData] = useState({});
  const generalFormError = useSelector(selectGeneralFormError);
  const ownerOrSitterFormError = useSelector(selectOwnerOrSitterFormError);

  const dispatch = useDispatch();
  const history = useHistory();
  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);

  const submitGeneralSignupForm = async (data) => {
    setFormData({
      ...formData,
      ...data,
    });
    setCurrentScreen(data.isPetOwner ? 1 : 2);
  };

  useEffect(() => {
    if (generalFormError && !generalFormError.includes('address')) {
      setCurrentScreen(0);
    }
  }, [generalFormError]);

  const submitSignupForm = async (secondaryFormData) => {
    console.log(secondaryFormData);
    const data = {
      ...formData,
      address: secondaryFormData.address,
      // TODO: Remove hardcoding when backend supports files
      verificationDetails: {
        driversLicense: "DLMEL2756",
        referenceEmail: "testreference@gmail.com",
      },
    };
    dispatch(signup(data));
  };

  if (isUserAuthenticated) {
    history.push('/dashboard');
    return null;
  }

  const screens = [(
    <GeneralSignupForm
      formSubmitError={generalFormError}
      submitForm={submitGeneralSignupForm}
    />
  ), (
    <OwnerSignupForm
      formSubmitError={ownerOrSitterFormError}
      submitForm={submitSignupForm}
    />
  ), (
    <PetSitterSignupForm
      formSubmitError={ownerOrSitterFormError}
      submitForm={submitSignupForm}
    />
  )];

  return screens[currentScreen];
};

export default Signup;
